var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransactions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.909 0 0 17.909 0 40v432c0 22.091 17.909 40 40 40h432c22.091 0 40-17.909 40-40V40c0-22.091-17.909-40-40-40H40zm124.571 384H91.429V256h73.143v128h-.001zm128 0h-73.143V128h73.143v256zm128 0h-73.143V201.143h73.143V384z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNDAgMEMxNy45MDg2IDAgMCAxNy45MDg2IDAgNDBWNDcyQzAgNDk0LjA5MSAxNy45MDg2IDUxMiA0MCA1MTJINDcyQzQ5NC4wOTEgNTEyIDUxMiA0OTQuMDkxIDUxMiA0NzJWNDBDNTEyIDE3LjkwODYgNDk0LjA5MSAwIDQ3MiAwSDQwWk0xNjQuNTcxIDM4NEg5MS40MjlWMjU2SDE2NC41NzJWMzg0SDE2NC41NzFaTTI5Mi41NzEgMzg0SDIxOS40MjhWMTI4SDI5Mi41NzFWMzg0Wk00MjAuNTcxIDM4NEgzNDcuNDI4VjIwMS4xNDNINDIwLjU3MVYzODRaIi8+Cjwvc3ZnPgo=";
export { SvgTransactions as ReactComponent };